import React from "react";
import { Page, Document, StyleSheet } from "@react-pdf/renderer";

import InvoiceTitle from "./InvoiceTitle";
import InvoiceNo from "./InvoiceNo";
import BillTo from "./BillTo";
import InvoiceThankYouMsg from "./InvoiceThankYouMsg";
import InvoiceItemsTable from "./InvoiceItemsTable";
import UniqueId from "./UniqueId";

const styles = StyleSheet.create({
  page: {
    backgroundColor: "#fff",
    fontFamily: "Helvetica",
    fontSize: 11,
    paddingTop: 30,
    paddingLeft: 50,
    paddingRight: 50,
    lineHeight: 1.5,
    flexDirection: "column",
    overflow: "hidden",
  },
  logo: {
    width: "180px",
    height: "56px",
    marginLeft: "5px",
    marginRight: "auto",
  },
});

const PdfDocument = ({ invoicedata, data }) => {
  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <UniqueId certificateNo={data?._id} />
        <InvoiceTitle title={"Certificate of Appreciation"} />
        <InvoiceNo invoice={invoicedata} />
        <BillTo invoice={invoicedata} />
        <InvoiceItemsTable invoice={invoicedata} data={data}/>
        <InvoiceThankYouMsg />
      </Page>
    </Document>
  );
};

export default PdfDocument;
